export const productStatuses = {
  active: 'Ativo',
  inactive: 'Inativo',
};
